import Cookies from "./Cookies";

export const getPageId = () => Cookies.getCookie("pageId");